type ImageLoading = "eager" | "lazy";
type FetchPriority = "high" | "auto" | "low";

export interface WinnerCardImageProps {
  loading: ImageLoading;
  fetchPriority: FetchPriority;
}

/** All cards in the first category swiper load eagerly with high priority; every other slider is lazy. */
export function getWinnerCardImageProps(isFirstSlider: boolean): WinnerCardImageProps {
  if (isFirstSlider) {
    return { loading: "eager", fetchPriority: "high" };
  }

  return { loading: "lazy", fetchPriority: "auto" };
}
